import type { StaticPage } from "~/types/Data/informative/pages";

const staticPages: StaticPage[] = [
  {
    key: "home",
    title: "Home Page",
    url: "/",
  },
  {
    key: "our-branches",
    title: "Our Branches",
    url: "/our-branches",
  },
  {
    key: "refund-policy",
    title: "Refund Policy",
    url: "/refund-policy",
  },
  {
    key: "shipping-policy",
    title: "Shipping Policy",
    url: "/shipping-policy",
  },
  {
    key: "terms-and-conditions",
    title: "Terms & Conditions",
    url: "/terms-and-conditions",
  },
  {
    key: "faqs",
    title: "FAQs",
    url: "/FAQs",
  },
  {
    key: "contact-us",
    title: "Contact Us",
    url: "/contact-us",
  },
];

export default defineNuxtPlugin(() => ({
  provide: {
    staticPages,
  },
}));
